import type { CellState } from '../types';

export const RACK_COLS = 4;
export const RACK_ROWS = 5;
export const RACK_TOTAL = RACK_ROWS * RACK_COLS;

export const COL_LETTERS = ['A', 'B', 'C', 'D'] as const;

export const CELL_STATES = {
  EMPTY: 'empty',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in-progress',
  COMPLETE: 'complete',
  FAILED: 'failed',
  SKIPPED: 'skipped'
} as const;

type ColorTokens = {
  border: { light: string; dark: string };
  background: { light: string; dark: string };
  text: { light: string; dark: string };
};

export const CELL_STATE_COLORS: Record<CellState, ColorTokens> = {
  empty: {
    border: { light: '#D1D5DB', dark: '#3A3A3C' },
    background: { light: '#F3F4F6', dark: '#1C1C1E' },
    text: { light: '#9CA3AF', dark: '#636366' }
  },
  assigned: {
    border: { light: '#E5A100', dark: '#F5A623' },
    background: {
      light: 'rgba(245, 166, 35, 0.08)',
      dark: 'rgba(245, 166, 35, 0.10)'
    },
    text: { light: '#92600A', dark: '#F5A623' }
  },
  'in-progress': {
    border: { light: '#D97706', dark: '#FBBF24' },
    background: {
      light: 'rgba(217, 119, 6, 0.08)',
      dark: 'rgba(251, 191, 36, 0.10)'
    },
    text: { light: '#92400E', dark: '#FBBF24' }
  },
  complete: {
    border: { light: '#16A34A', dark: '#34C759' },
    background: {
      light: 'rgba(34, 197, 94, 0.08)',
      dark: 'rgba(52, 199, 89, 0.10)'
    },
    text: { light: '#166534', dark: '#34C759' }
  },
  failed: {
    border: { light: '#DC2626', dark: '#FF3B30' },
    background: {
      light: 'rgba(239, 68, 68, 0.08)',
      dark: 'rgba(255, 59, 48, 0.10)'
    },
    text: { light: '#991B1B', dark: '#FF3B30' }
  },
  skipped: {
    border: { light: '#9CA3AF', dark: '#8E8E93' },
    background: {
      light: 'rgba(156, 163, 175, 0.08)',
      dark: 'rgba(142, 142, 147, 0.10)'
    },
    text: { light: '#6B7280', dark: '#8E8E93' }
  }
} as const;

export const RACK_THEME = {
  frameBg: { light: '#F9FAFB', dark: '#1C1C1E' },
  frameAccent: { light: '#FFFFFF', dark: '#2A2A2C' },
  grooveLine: { light: '#E5E7EB', dark: '#3A3A3C' },
  labelColor: { light: '#6B7280', dark: '#8E8E93' }
} as const;
